module.exports = __webpack_public_path__ + "static/media/sara-forbes-bonetta.775bd3c2.jpg";